import React from 'react';
import Button from '../ui/Button';
import { StatusPill } from '../ui/Status';

const ROUTE_LABELS = {
  '/goals': 'Goals',
  '/allocations': 'Allocations',
  '/actuals': 'Actuals'
};

function SelectedKpiWorkflowActionBar({ currentPath, onNavigate, selectedKpiKey, selectedKpiMeta }) {
  const title = selectedKpiMeta?.kpiLabel || selectedKpiKey;
  const subtitleParts = [selectedKpiMeta?.category, selectedKpiMeta?.goalName].filter(Boolean);

  const navigateTo = (path) => {
    if (currentPath === path) {
      return;
    }

    if (typeof onNavigate === 'function') {
      onNavigate(path);
      return;
    }

    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  return (
    <section className="director-card director-selected-kpi-bar">
      <div className="director-selected-kpi-copy">
        <span className="summary-card-label">Selected KPI</span>
        <strong>{title}</strong>
        <p>
          {subtitleParts.length ? `${subtitleParts.join(' / ')}` : 'Move this KPI through the workflow without losing your place.'}
        </p>
      </div>
      <div className="director-selected-kpi-meta">
        {selectedKpiMeta?.statusLabel ? (
          <div className="director-row-status">
            <StatusPill tone={selectedKpiMeta.statusTone || 'not-required'}>{selectedKpiMeta.statusLabel}</StatusPill>
            {selectedKpiMeta.statusDetail ? <div className="director-muted">{selectedKpiMeta.statusDetail}</div> : null}
          </div>
        ) : null}
        <div className="director-selected-kpi-actions">
          {Object.entries(ROUTE_LABELS).map(([path, label]) => (
            <Button
              key={path}
              size="sm"
              variant={currentPath === path ? 'secondary' : 'primary'}
              onClick={() => navigateTo(path)}
            >
              {currentPath === path ? `${label} (Current)` : `Go to ${label}`}
            </Button>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SelectedKpiWorkflowActionBar;
